/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboBranchConfigBadRequestResponse,
  BboBranchConfigFailureResponseResponse,
  BboBranchConfigForbiddenResponse,
  BboBranchConfigUnauthorizedResponse,
  BranchTcAppendixResponseResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get TC appendix based on appendix type
 */
export const branchTcAppendix = (appendixType: 'AppendixA' | 'AppendixB', signal?: AbortSignal) => {
  return customInstance<BranchTcAppendixResponseResponse>({
    url: `/BboBranchConfigService/v1/branch-tc-appendix/${appendixType}`,
    method: 'get',
    signal,
  });
};

export const getBranchTcAppendixQueryKey = (appendixType: 'AppendixA' | 'AppendixB') => {
  return [`/BboBranchConfigService/v1/branch-tc-appendix/${appendixType}`] as const;
};

export const getBranchTcAppendixQueryOptions = <
  TData = Awaited<ReturnType<typeof branchTcAppendix>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  appendixType: 'AppendixA' | 'AppendixB',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof branchTcAppendix>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBranchTcAppendixQueryKey(appendixType);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof branchTcAppendix>>> = ({ signal }) =>
    branchTcAppendix(appendixType, signal);

  return { queryKey, queryFn, enabled: !!appendixType, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof branchTcAppendix>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BranchTcAppendixQueryResult = NonNullable<Awaited<ReturnType<typeof branchTcAppendix>>>;
export type BranchTcAppendixQueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Get TC appendix based on appendix type
 */
export const useBranchTcAppendix = <
  TData = Awaited<ReturnType<typeof branchTcAppendix>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  appendixType: 'AppendixA' | 'AppendixB',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof branchTcAppendix>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBranchTcAppendixQueryOptions(appendixType, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
